var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Drendericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9585 2.03998C40.6873 0.768921 38.9216 0.125 36.7117 0.125C33.7659 0.125 30.1262 1.32529 26.2531 3.44665L29.7069 5.17318C32.3369 3.93607 34.7468 3.25 36.7117 3.25C38.0639 3.25 39.0849 3.58569 39.7488 4.24945C42.7933 7.29358 38.8941 17.9763 28.4341 28.4377C21.0676 35.8016 12.5656 40.75 7.27911 40.75C5.9269 40.75 4.90596 40.4143 4.24206 39.7505C2.48569 37.9945 3.0542 33.6899 5.84601 28.3587L3.03045 26.9513C-0.33673 33.4074 -0.919167 39.008 2.03232 41.96C3.30355 43.2311 5.06927 43.875 7.27911 43.875C13.4339 43.875 22.6059 38.6824 30.6439 30.6472C42.0226 19.2687 46.8878 6.97009 41.9585 2.03998Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9489 6.53979L16.4489 0.289795C16.0094 0.0700684 15.4906 0.0700684 15.0511 0.289795L2.55115 6.53979C2.02167 6.8053 1.6875 7.34546 1.6875 7.9375V23.5625C1.6875 24.1545 2.02167 24.6947 2.55115 24.9602L15.0511 31.2102C15.2709 31.3201 15.5104 31.375 15.75 31.375C15.9896 31.375 16.2291 31.3201 16.4489 31.2102L28.9489 24.9602C29.4783 24.6947 29.8125 24.1545 29.8125 23.5625V7.9375C29.8125 7.34546 29.4783 6.8053 28.9489 6.53979ZM15.75 3.43463L24.7557 7.9375L15.75 12.4404L6.74426 7.9375L15.75 3.43463ZM4.8125 10.4659L14.1875 15.1534V27.2841L4.8125 22.5966V10.4659ZM17.3125 27.2841V15.1534L26.6875 10.4659V22.5966L17.3125 27.2841Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Drendericon);
export default __webpack_public_path__ + "static/media/3drendericon.0bf530d24628fcf18eeee22ba1e6a5b9.svg";
export { ForwardRef as ReactComponent };